import { PublicClientApplication, Configuration, AuthenticationResult } from "@azure/msal-browser";

const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID, 
    authority: "https://login.microsoftonline.com/" + process.env.REACT_APP_TENANT_ID, 
    redirectUri: process.env.REACT_APP_REDIRECT_URL,
  },
};
const loginRequest = {
    scopes: ["User.ReadWrite.All"],
};

const msalInstance = new PublicClientApplication(msalConfig);
let account = null;

export const PropLogin = async () => {
    try {
        const response: AuthenticationResult = await msalInstance.loginPopup(loginRequest);
        account = response.account;

        return response.accessToken;
    } catch (error) {
        console.error("Login Error:", error);
    }
};

export const GetToken = async () => {

    try {
        const response: AuthenticationResult = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: account,
        });
        return response.accessToken;
    } catch (error) {
        return null;
    }
}





export default msalInstance;